<template>
  <v-icon @click="edit = !edit" v-if="isClubManager" color="primary" size="40" >{{ edit ? 'mdi-arrow-u-left-top' : 'mdi-pencil' }}</v-icon>
  <v-icon @click="openCreateDialog" v-if="isClubManager && edit" color="green" size="40">mdi-plus-thick</v-icon>

  <h3 class="mt-3">{{ $t('club.rules.title_current_rules') }}</h3>

  <div v-if="Object.keys(actual_rules).length && !edit">
    <v-row>
      <v-col cols="12" md="3">
        <v-list-item>
          <v-list-item-title class="d-inline">{{ $t('club.rules.valid_from') }}</v-list-item-title>
          {{ $formatDate(actual_rules.valid_from) }}
        </v-list-item>
        <v-list-item v-if="actual_rules.description">
          <v-list-item-title class="d-inline">{{ $t('club.rules.description') }}</v-list-item-title>
          {{ actual_rules.description }}
        </v-list-item>
      </v-col>
      <v-col cols="12" md="3" v-if="actual_rules.automodule_amortization || actual_rules.automodule_petrol_price || actual_rules.automodule_diesel_price || actual_rules.automodule_consumption">
        <h4>{{ $t('club.rules.current_prices') }}</h4>
        <v-list-item v-if="actual_rules.automodule_amortization">
          <v-list-item-title class="d-inline">{{ $t('club.rules.amortization') }}</v-list-item-title>
          {{ actual_rules.automodule_amortization }} {{currencySymbol(props.eventCurrency) }}/km
        </v-list-item>
        <v-list-item v-if="actual_rules.automodule_petrol_price">
          <v-list-item-title class="d-inline">{{ $t('club.rules.petrol_price') }}</v-list-item-title>
          {{ actual_rules.automodule_petrol_price }} {{currencySymbol(props.eventCurrency) }}/l
        </v-list-item>
        <v-list-item v-if="actual_rules.automodule_diesel_price">
          <v-list-item-title class="d-inline">{{ $t('club.rules.diesel_price') }}</v-list-item-title>
          {{ actual_rules.automodule_diesel_price }} {{currencySymbol(props.eventCurrency) }}/l
        </v-list-item>

        <v-list-item v-if="actual_rules.automodule_consumption">
          <v-list-item-title class="d-inline">{{ $t('club.rules.consumption') }}</v-list-item-title>
          <span v-if="actual_rules.automodule_consumption">
            &nbsp;<v-icon color="green">mdi-check-circle</v-icon> {{ $t('club.rules.consumption_info') }}
          </span>
          <span v-else>
            <v-icon color="red">mdi-close-circle</v-icon> Ne
          </span>
        </v-list-item>
      </v-col>
      <v-col cols="12" md="3" v-if="actual_rules.automodule_price_index_1 || actual_rules.automodule_price_index_2 || actual_rules.automodule_price_index_3 || actual_rules.automodule_price_index_4 || actual_rules.automodule_price_index_5 || actual_rules.automodule_price_index_6">
        <h4>{{ $t('club.rules.section_fixed_by_people') }}</h4>
        <v-list-item v-if="actual_rules.automodule_price_index_1">
          <v-list-item-title class="d-inline">{{ $t('club.rules.label_1_person_prefix') }} - </v-list-item-title>
          {{ actual_rules.automodule_price_index_1 }} {{currencySymbol(props.eventCurrency) }}/km
        </v-list-item>
        <v-list-item v-if="actual_rules.automodule_price_index_2">
          <v-list-item-title class="d-inline">{{ $t('club.rules.label_2_people_prefix') }} - </v-list-item-title>
          {{ actual_rules.automodule_price_index_2 }} {{currencySymbol(props.eventCurrency) }}/km
        </v-list-item>
        <v-list-item v-if="actual_rules.automodule_price_index_3">
          <v-list-item-title class="d-inline">{{ $t('club.rules.label_3_people_prefix') }} - </v-list-item-title>
          {{ actual_rules.automodule_price_index_3 }} {{currencySymbol(props.eventCurrency) }}/km
        </v-list-item>
        <v-list-item v-if="actual_rules.automodule_price_index_4">
          <v-list-item-title class="d-inline">{{ $t('club.rules.label_4_people_prefix') }} - </v-list-item-title>
          {{ actual_rules.automodule_price_index_4 }} {{currencySymbol(props.eventCurrency) }}/km
        </v-list-item>
        <v-list-item v-if="actual_rules.automodule_price_index_5">
          <v-list-item-title class="d-inline">{{ $t('club.rules.label_5_people_prefix') }} - </v-list-item-title>
          {{ actual_rules.automodule_price_index_5 }} {{currencySymbol(props.eventCurrency) }}/km
        </v-list-item>
        <v-list-item v-if="actual_rules.automodule_price_index_6">
          <v-list-item-title class="d-inline">{{ $t('club.rules.label_more_than_5_people_prefix') }} - </v-list-item-title>
          {{ actual_rules.automodule_price_index_6 }} {{currencySymbol(props.eventCurrency) }}/km
        </v-list-item>
      </v-col>

      <v-col cols="12" md="3">
        <v-card color="entry-surface" class="pa-4 mr-1" elevation="3">
          <h4>{{ $t('club.rules.section_competition_contribs') }}</h4>

          <v-list-item>
            <v-list-item-title class="d-inline">{{ $t('club.rules.start_fee_contribution') }}</v-list-item-title>
            {{ actual_rules.start_fee_contribution }} %
          </v-list-item>

          <v-list-item>
            <v-list-item-title class="d-inline">{{ $t('club.rules.accommodation_contribution') }}</v-list-item-title>
            {{ actual_rules.accommodation_contribution }} %
          </v-list-item>

          <v-list-item>
            <v-list-item-title class="d-inline">{{ $t('club.rules.food_contribution') }}</v-list-item-title>
            {{ actual_rules.food_contribution }} %
          </v-list-item>

          <v-list-item>
            <v-list-item-title class="d-inline">{{ $t('club.rules.automodule_contribution') }}</v-list-item-title>
            {{ actual_rules.automodule_contribution }} %
          </v-list-item>
        </v-card>
      </v-col>



    </v-row>
  </div>

  <div v-if="Object.keys(actual_rules).length === 0">{{ $t('club.rules.no_rules_set') }}</div>


  <v-form v-if="Object.keys(actual_rules).length && edit" ref="formRef" v-model="formValid" class="mb-5">
    <v-alert type="warning" class="mb-2">{{ $t('club.rules.edit_warning') }} <v-icon @click="openCreateDialog" v-if="isClubManager && edit" color="green" size="30">mdi-plus-thick</v-icon></v-alert>
    <v-row>
      <v-col cols="12" md="3">
        <v-text-field
          v-model="editRules.valid_from"
          :label="$t('club.rules.field_valid_from')"
          type="date"
          density="comfortable"
          :rules="[
            v => v !== null && v !== '' || $t('rules.required')          
            ]"
        />
        <v-textarea
          v-model="editRules.description"
          :label="$t('club.rules.field_description')"
          maxlength="80"
          counter
          density="comfortable"
          rows="2"
        />
        <v-text-field
          v-model="editRules.automodule_amortization"
          :label="$t('club.rules.field_amortization')"
          type="number"
          density="comfortable"
          :suffix="`${currencySymbol(props.eventCurrency)}/km`"
          min="0"
          step="0.1"
          :rules="[
            v => v === null || v === '' || v >= 0 || $t('club.rules.validation_positive'),
            v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || $t('club.rules.validation_max_3_digits_1_decimal')
          ]"
        />
        <v-text-field
          v-model="editRules.automodule_petrol_price"
          :label="$t('club.rules.field_petrol_price')"
          type="number"
          density="comfortable"
          :suffix="`${currencySymbol(props.eventCurrency)}/l`"
          min="0"
          step="0.1"
          :rules="[
            v => v === null || v === '' || v >= 0 || $t('club.rules.validation_positive'),
            v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || $t('club.rules.validation_max_3_digits_1_decimal')
          ]"
          :error="!!fuelConsumptionError"
          :error-messages="fuelConsumptionError"
        />
        
        <v-text-field
          v-model="editRules.automodule_diesel_price"
          :label="$t('club.rules.field_diesel_price')"
          type="number"
          density="comfortable"
          :suffix="`${currencySymbol(props.eventCurrency)}/l`"
          min="0"
          step="0.1"
          :rules="[
            v => v === null || v === '' || v >= 0 || $t('club.rules.validation_positive'),
            v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || $t('club.rules.validation_max_3_digits_1_decimal')
          ]"
          :error="!!fuelConsumptionError"
          :error-messages="fuelConsumptionError"
        />

        <v-switch
          v-model="editRules.automodule_consumption"
          :label="$t('club.rules.switch_count_consumption')"
          density="comfortable"
          class="ml-4"
          suffix="l/100km"
          color="primary"
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          v-model="editRules.automodule_price_index_1"
          :label="$t('club.rules.field_rate_1_person')"
          type="number"
          density="comfortable"
          :suffix="`${currencySymbol(props.eventCurrency)}/km`"
          :rules="[
            v => v === null || v === '' || v >= 0 || $t('club.rules.validation_positive'),
            v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || $t('club.rules.validation_max_3_digits_1_decimal')
          ]"
        />
        <v-text-field
          v-model="editRules.automodule_price_index_2"
          :label="$t('club.rules.field_rate_2_people')"
          type="number"
          density="comfortable"
          :suffix="`${currencySymbol(props.eventCurrency)}/km`"
          :rules="[
            v => v === null || v === '' || v >= 0 || $t('club.rules.validation_positive'),
            v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || $t('club.rules.validation_max_3_digits_1_decimal')
          ]"
        />
        <v-text-field
          v-model="editRules.automodule_price_index_3"
          :label="$t('club.rules.field_rate_3_people')"
          type="number"
          density="comfortable"
          :suffix="`${currencySymbol(props.eventCurrency)}/km`"
          :rules="[
            v => v === null || v === '' || v >= 0 || $t('club.rules.validation_positive'),
            v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || $t('club.rules.validation_max_3_digits_1_decimal')
          ]"
        />
        <v-text-field
          v-model="editRules.automodule_price_index_4"
          :label="$t('club.rules.field_rate_4_people')"
          type="number"
          density="comfortable"
          :suffix="`${currencySymbol(props.eventCurrency)}/km`"
          :rules="[
            v => v === null || v === '' || v >= 0 || $t('club.rules.validation_positive'),
            v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || $t('club.rules.validation_max_3_digits_1_decimal')
          ]"
        />
        <v-text-field
          v-model="editRules.automodule_price_index_5"
          :label="$t('club.rules.field_rate_5_people')"
          type="number"
          density="comfortable"
          :suffix="`${currencySymbol(props.eventCurrency)}/km`"
          :rules="[
            v => v === null || v === '' || v >= 0 || $t('club.rules.validation_positive'),
            v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || $t('club.rules.validation_max_3_digits_1_decimal')
          ]"
        />
        <v-text-field
          v-model="editRules.automodule_price_index_6"
          :label="$t('club.rules.field_rate_6_people')"
          type="number"
          density="comfortable"
          :suffix="`${currencySymbol(props.eventCurrency)}/km`"
          :rules="[
            v => v === null || v === '' || v >= 0 || $t('club.rules.validation_positive'),
            v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || $t('club.rules.validation_max_3_digits_1_decimal')
          ]"
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          v-model="editRules.start_fee_contribution"
          :label="$t('club.rules.field_reimburse_start_fee')"
          type="number"
          density="comfortable"
          suffix="%"
          :rules="[
            v => v !== null && v !== '' || $t('club.rules.validation_number_0_100_required'),
            v => (v >= 0 && v <= 100) || $t('club.rules.validation_between_0_100')
          ]"
        />

        <v-text-field
          v-model="editRules.accommodation_contribution"
          :label="$t('club.rules.field_reimburse_accommodation')"
          type="number"
          density="comfortable"
          suffix="%"
          :rules="[
            v => v !== null && v !== '' || $t('club.rules.validation_number_0_100_required'),
            v => (v >= 0 && v <= 100) || $t('club.rules.validation_between_0_100')
          ]"
        />

        <v-text-field
          v-model="editRules.food_contribution"
          :label="$t('club.rules.field_reimburse_food')"
          type="number"
          density="comfortable"
          suffix="%"
          :rules="[
            v => v !== null && v !== '' || $t('club.rules.validation_number_0_100_required'),
            v => (v >= 0 && v <= 100) || $t('club.rules.validation_between_0_100')
          ]"
        />

        <v-text-field
          v-model="editRules.automodule_contribution"
          :label="$t('club.rules.field_reimburse_transport')"
          type="number"
          density="comfortable"
          suffix="%"
          :rules="[
            v => v !== null && v !== '' || $t('club.rules.validation_number_0_100_required'),
            v => (v >= 0 && v <= 100) || $t('club.rules.validation_between_0_100')
          ]"
        />

      </v-col>

    </v-row>
    <v-btn @click="submitEditClubPaymentsRules" :disabled="!formValid" color="primary">
      {{ $t('general.save') }}
    </v-btn>
  </v-form>


  <!-- Dialog pro vytvoření nových pravidel financí oddílu -->
  <v-dialog v-model="createDialog" max-width="1000px">
    <v-card>
      <v-card-title class="text-h5">{{ $t('club.rules.create_title') }}</v-card-title>
      <v-card-text>
        <v-form ref="formRef" v-model="formValid" class="mb-5">
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="newRules.valid_from"
                :label="$t('club.rules.field_valid_from')"
                type="date"
                density="comfortable"
                :rules="[
                    v => v !== null && v !== '' || $t('rules.required')
                  ]"
              />
              <v-text-field
                v-model="newRules.description"
                :label="$t('club.rules.field_description')"
                maxlength="80"
                counter
                density="comfortable"
              />
              <v-text-field
                v-model="newRules.automodule_amortization"
                :label="$t('club.rules.field_amortization')"
                type="number"
                density="comfortable"
                :suffix="`${currencySymbol(props.eventCurrency)}/km`"
                min="0"
                step="0.1"
                :rules="[
                  v => v === null || v === '' || v >= 0 || $t('club.rules.validation_positive'),
                  v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || $t('club.rules.validation_max_3_digits_1_decimal')
                ]"
              />
              <v-text-field
                v-model="newRules.automodule_petrol_price"
                :label="$t('club.rules.field_petrol_price')"
                type="number"
                density="comfortable"
                :suffix="`${currencySymbol(props.eventCurrency)}/l`"
                min="0"
                step="0.1"
                :rules="[
                  v => v === null || v === '' || v >= 0 || $t('club.rules.validation_positive'),
                  v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || $t('club.rules.validation_max_3_digits_1_decimal')
                ]"
                :error="!!fuelConsumptionErrorCreate"
                :error-messages="fuelConsumptionErrorCreate"
              />
                            <v-text-field
                v-model="newRules.automodule_diesel_price"
                :label="$t('club.rules.field_diesel_price')"
                type="number"
                density="comfortable"
                :suffix="`${currencySymbol(props.eventCurrency)}/l`"
                min="0"
                step="0.1"
                :rules="[
                  v => v === null || v === '' || v >= 0 || $t('club.rules.validation_positive'),
                  v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || $t('club.rules.validation_max_3_digits_1_decimal')
                ]"
                :error="!!fuelConsumptionErrorCreate"
                :error-messages="fuelConsumptionErrorCreate"
              />
              <v-switch
                v-model="newRules.automodule_consumption"
                :label="$t('club.rules.switch_count_consumption')"
                density="comfortable"
                class="ml-4"
                suffix="l/100km"
                color="primary"
              />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="newRules.automodule_price_index_1"
              :label="$t('club.rules.field_rate_1_person')"
              type="number"
              density="comfortable"
              :suffix="`${currencySymbol(props.eventCurrency)}/km`"
              :rules="[
                  v => v === null || v === '' || v >= 0 || $t('club.rules.validation_positive'),
                  v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || $t('club.rules.validation_max_3_digits_1_decimal')
                ]"
            />
            <v-text-field
              v-model="newRules.automodule_price_index_2"
              :label="$t('club.rules.field_rate_2_people')"
              type="number"
              density="comfortable"
              :suffix="`${currencySymbol(props.eventCurrency)}/km`"
              :rules="[
                  v => v === null || v === '' || v >= 0 || $t('club.rules.validation_positive'),
                  v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || $t('club.rules.validation_max_3_digits_1_decimal')
                ]"
            />
            <v-text-field
              v-model="newRules.automodule_price_index_3"
              :label="$t('club.rules.field_rate_3_people')"
              type="number"
              density="comfortable"
              :suffix="`${currencySymbol(props.eventCurrency)}/km`"
              :rules="[
                  v => v === null || v === '' || v >= 0 || $t('club.rules.validation_positive'),
                  v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || $t('club.rules.validation_max_3_digits_1_decimal')
                ]"
            />
            <v-text-field
              v-model="newRules.automodule_price_index_4"
              :label="$t('club.rules.field_rate_4_people')"
              type="number"
              density="comfortable"
              :suffix="`${currencySymbol(props.eventCurrency)}/km`"
              :rules="[
                  v => v === null || v === '' || v >= 0 || $t('club.rules.validation_positive'),
                  v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || $t('club.rules.validation_max_3_digits_1_decimal')
                ]"
            />
            <v-text-field
              v-model="newRules.automodule_price_index_5"
              :label="$t('club.rules.field_rate_5_people')"
              type="number"
              density="comfortable"
              :suffix="`${currencySymbol(props.eventCurrency)}/km`"
              :rules="[
                  v => v === null || v === '' || v >= 0 || $t('club.rules.validation_positive'),
                  v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || $t('club.rules.validation_max_3_digits_1_decimal')
                ]"
            />
            <v-text-field
              v-model="newRules.automodule_price_index_6"
              :label="$t('club.rules.field_rate_6_people')"
              type="number"
              density="comfortable"
              :suffix="`${currencySymbol(props.eventCurrency)}/km`"
              :rules="[
                  v => v === null || v === '' || v >= 0 || $t('club.rules.validation_positive'),
                  v => v === null || v === '' || /^(\d{1,2})([.,]\d)?$/.test(v) || $t('club.rules.validation_max_3_digits_1_decimal')
                ]"
            />
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field
              v-model="newRules.start_fee_contribution"
              :label="$t('club.rules.field_reimburse_start_fee')"
              type="number"
              density="comfortable"
              suffix="%"
              :rules="[
                v => v === null || v === '' || (v >= 0 && v <= 100) || $t('club.rules.validation_between_0_100')
              ]"
            />

            <v-text-field
              v-model="newRules.accommodation_contribution"
              :label="$t('club.rules.field_reimburse_accommodation')"
              type="number"
              density="comfortable"
              suffix="%"
              :rules="[
                v => v === null || v === '' || (v >= 0 && v <= 100) || $t('club.rules.validation_between_0_100')
              ]"
            />



            <v-text-field
              v-model="newRules.food_contribution"
              :label="$t('club.rules.field_reimburse_food')"
              type="number"
              density="comfortable"
              suffix="%"
              :rules="[
                v => v === null || v === '' || (v >= 0 && v <= 100) || $t('club.rules.validation_between_0_100')
              ]"
            />

            <v-text-field
              v-model="newRules.automodule_contribution"
              :label="$t('club.rules.field_reimburse_transport')"
              type="number"
              density="comfortable"
              suffix="%"
              :rules="[
                v => v === null || v === '' || (v >= 0 && v <= 100) || $t('club.rules.validation_between_0_100')
              ]"
            />
          </v-col>

        </v-row>
      </v-form>
      <v-alert type="info" class="my-2" density="compact">{{ $t('club.rules.create_info') }}</v-alert>
    </v-card-text>
    <v-card-actions>
      <v-btn color="grey" text @click="createDialog = false">{{ $t('general.cancel') }}</v-btn>
      <v-spacer />
      <v-btn color="green" :disabled="!formValid" @click="submitCreateClubPaymentsRules">{{ $t('general.create') }}</v-btn>
    </v-card-actions>
    </v-card>
  </v-dialog>



  <h2>{{ $t('club.rules.history_title') }}</h2>
  <v-data-table
    :headers="headers"
    :items="payments_rules"
    :loading="isLoading"
    hide-default-footer
    loading-text="general.loading"
    density="compact"
    :sort-by="[{ key: 'valid_from', order: 'desc' }]"
    :items-per-page="-1"
    style="white-space: nowrap"
  >
    <template v-slot:[`item.valid_from`]="{ item }">
      {{ $formatDate(item.valid_from) }}
    </template>

    <template v-slot:[`item.valid_to`]="{ item }">
      {{ item.valid_to ? $formatDate(item.valid_to) : '' }}
    </template>

    <template v-slot:[`item.description`]="{ item }">
      <span style="white-space: normal !important; word-break: break-word;">{{ item.description }}</span>
    </template>

    <template v-slot:[`item.automodule_amortization`]="{ item }">
      {{ item.automodule_amortization ? item.automodule_amortization : '--'  }} {{currencySymbol(props.eventCurrency) }}/km
    </template>

    <template v-slot:[`item.automodule_petrol_price`]="{ item }">
      {{ item.automodule_petrol_price ? item.automodule_petrol_price : '--'  }} {{currencySymbol(props.eventCurrency) }}/l
    </template>

        <template v-slot:[`item.automodule_diesel_price`]="{ item }">
      {{ item.automodule_diesel_price ? item.automodule_diesel_price : '--'  }} {{currencySymbol(props.eventCurrency) }}/l
    </template>


    <template v-slot:[`item.automodule_price_index_1`]="{ item }">
      {{ item.automodule_price_index_1 ? item.automodule_price_index_1 : '--'  }} {{currencySymbol(props.eventCurrency) }}/km
    </template>

    <template v-slot:[`item.automodule_price_index_2`]="{ item }">
      {{ item.automodule_price_index_2 ? item.automodule_price_index_2 : '--' }} {{currencySymbol(props.eventCurrency) }}/km
    </template>

    <template v-slot:[`item.automodule_price_index_3`]="{ item }">
      {{ item.automodule_price_index_3 ? item.automodule_price_index_3 : '--' }} {{currencySymbol(props.eventCurrency) }}/km
    </template>

    <template v-slot:[`item.automodule_price_index_4`]="{ item }">
      {{ item.automodule_price_index_4 ? item.automodule_price_index_4 : '--' }} {{currencySymbol(props.eventCurrency) }}/km
    </template>

    <template v-slot:[`item.automodule_price_index_5`]="{ item }">
      {{ item.automodule_price_index_5 ? item.automodule_price_index_5 : '--' }} {{currencySymbol(props.eventCurrency) }}/km
    </template>

    <template v-slot:[`item.automodule_price_index_6`]="{ item }">
      {{ item.automodule_price_index_6 ? item.automodule_price_index_6 : '--' }} {{currencySymbol(props.eventCurrency) }}/km
    </template>

    <template v-slot:[`item.automodule_consumption`]="{ item }">
      <div class="text-center">
        <v-icon v-if="item.automodule_consumption" color="green">mdi-check-circle</v-icon>
        <v-icon v-else color="red">mdi-close-circle</v-icon>
      </div>
    </template>

    <template v-slot:[`item.start_fee_contribution`]="{ item }">
      {{ item.start_fee_contribution }} %
    </template>
    <template v-slot:[`item.accommodation_contribution`]="{ item }">
      {{ item.accommodation_contribution }} %
    </template>
    <template v-slot:[`item.food_contribution`]="{ item }">
      {{ item.food_contribution }} %
    </template>
    <template v-slot:[`item.automodule_contribution`]="{ item }">
      {{ item.automodule_contribution }} %
    </template>

  </v-data-table>
</template>

<script setup>
import { ref, computed, watch, nextTick } from 'vue'
import apiClient from '/api.js'
import { useRoute } from 'vue-router'
import {useSnackbarStore} from '@/stores/snackbarStore'
import {useI18n} from 'vue-i18n'
import { currencySymbol } from '@/components/const/enums.js';



const props = defineProps({
  activeTab: {
    type: String,
    required: true,
  },
  isClubManager: {
    type: Boolean,
    default: false
  },
  eventCurrency: {
    type: String,
    default: currencySymbol.CZK
  }
})

const { t } = useI18n()
// Aktivní záložka club_payments_rules
const isTabActive = computed(() => props.activeTab === 'club_payments_rules')
const snackbar = useSnackbarStore()
const route = useRoute()
const club_shortcut = computed(() => route.params.id)
const edit = ref(false);

const isLoading = ref(false)
const payments_rules = ref([])
const actual_rules = ref({})

const fetchPaymentsRules = async () => {
  isLoading.value = true
  try {
    const response = await apiClient.get(`/club/payments_rules/?club_shortcut=${club_shortcut.value}`)
    payments_rules.value = response.data
    actual_rules.value = response.data && response.data.length > 0 ? response.data[0] : {}
  } catch (error) {
    console.error(error)
  } finally {
    isLoading.value = false
  }
}

// Definice hlaviček tabulky se všemi poli z API
const headers = [
  { title: t('club.rules.th_valid_from'), value: 'valid_from' },
  { title: t('club.rules.th_valid_to'), value: 'valid_to' },
  { title: t('club.rules.th_description'), value: 'description', maxWidth: 180, minWidth: 180 },
  { title: t('club.rules.th_amortization_short'), value: 'automodule_amortization' },
  { title: t('club.rules.th_petrol'), value: 'automodule_petrol_price' },
  { title: t('club.rules.th_diesel'), value: 'automodule_diesel_price' },
  { title: t('club.rules.th_consumption'), value: 'automodule_consumption', maxWidth: 80},
  { title: t('club.rules.th_people_1'), value: 'automodule_price_index_1' },
  { title: t('club.rules.th_people_2'), value: 'automodule_price_index_2' },
  { title: t('club.rules.th_people_3'), value: 'automodule_price_index_3' },
  { title: t('club.rules.th_people_4'), value: 'automodule_price_index_4' },
  { title: t('club.rules.th_people_5'), value: 'automodule_price_index_5' },
  { title: t('club.rules.th_people_6_plus'), value: 'automodule_price_index_6' },
  { title: t('club.rules.th_start_fee'), value: 'start_fee_contribution' },
  { title: t('club.rules.th_accommodation'), value: 'accommodation_contribution' },
  { title: t('club.rules.th_food'), value: 'food_contribution' },
  { title: t('club.rules.th_transport'), value: 'automodule_contribution' }
]

// Sledujeme, zda je záložka aktivní
watch(isTabActive, (active) => {
  if (active) {
    fetchPaymentsRules()
  }
}, { immediate: true })


const fuelConsumptionError = computed(() => {
  const petrol = editRules.value.automodule_petrol_price
  const diesel = editRules.value.automodule_diesel_price
  const consumption = editRules.value.automodule_consumption

  const petrolEmpty = petrol === null || petrol === '' || Number(petrol) === 0
  const dieselEmpty = diesel === null || diesel === '' || Number(diesel) === 0

  if (consumption && (petrolEmpty || dieselEmpty)) {
    return t('club.rules.error_need_both_fuel_prices')
  }
  if (!consumption && (!petrolEmpty || !dieselEmpty)) {
    return t('club.rules.error_enable_consumption_toggle')
  }
  return ''
})


// Nastavení null hodnot místo "" když se hodnota z formuláře edit a create smaže

const normalizeEmptyToNull = (obj) => {
  const copy = { ...obj };
  Object.keys(copy).forEach((key) => {
    if (copy[key] === "" && key !== 'description') {
      copy[key] = null;
    }
  });
  return copy;
};

const formValid = ref(false)
const editRules = ref({})

const submitEditClubPaymentsRules = async () => {
  try {
    const payload = normalizeEmptyToNull({ ...editRules.value });
    await apiClient.put(`/club/payments_rules/?rule_id=${editRules.value.id}`, payload);

    await fetchPaymentsRules()
    edit.value = false
    snackbar.success(t('club.rules.rules_updated'))
  } catch (error) {
    const detail = error.response?.data?.error || error.response?.data?.detail || 'Neznámá chyba.';
    snackbar.error(t('club.rules.error_save_failed', { detail }));
    console.error(error)
  }
}


// Kdykoliv se přepne edit mód na true, zkopíruj aktuální pravidla
watch(edit, (isEditing) => {
  if (isEditing && actual_rules.value) {
    editRules.value = { ...actual_rules.value }
  }
})

// kdykoliv actual_rules dorazí nové a jsi v edit modu, překopíruj je do formuláře, aby se při zaplém edit modu a přepnutí na jíný club hodnoty aktualizovaly
watch(actual_rules, (newRules) => {
  if (edit.value && newRules) {
    editRules.value = { ...newRules }
  }
})



const createDialog = ref(false)
const newRules = ref({})
const formRef = ref(null)

const openCreateDialog = () => {
  // inicializace výchozích hodnot
  newRules.value = {
    valid_from: '',
    description: '',
    automodule_amortization: null,
    automodule_petrol_price: null,
    automodule_diesel_price: null,
    automodule_consumption: false,
    automodule_price_index_1: null,
    automodule_price_index_2: null,
    automodule_price_index_3: null,
    automodule_price_index_4: null,
    automodule_price_index_5: null,
    automodule_price_index_6: null,
    automodule_contribution: 0,
    start_fee_contribution: 0,
    accommodation_contribution: 0,
    food_contribution: 0,
  }
  createDialog.value = true
  nextTick(() => formRef.value?.validate())
}

const fuelConsumptionErrorCreate = computed(() => {
  const petrol = newRules.value.automodule_petrol_price
  const diesel = newRules.value.automodule_diesel_price
  const consumption = newRules.value.automodule_consumption

  const petrolEmpty = petrol === null || petrol === '' || Number(petrol) === 0
  const dieselEmpty = diesel === null || diesel === '' || Number(diesel) === 0

  if (consumption && (petrolEmpty || dieselEmpty)) {
    return t('club.rules.error_need_both_fuel_prices')
  }
  if (!consumption && (!petrolEmpty || !dieselEmpty)) {
    return t('club.rules.error_enable_consumption_toggle')
  }
  return ''
})



const submitCreateClubPaymentsRules = async () => {
  try {
    const payload = normalizeEmptyToNull({ ...newRules.value });
    await apiClient.post(`/club/payments_rules/?club_shortcut=${club_shortcut.value}`, payload) 

    await fetchPaymentsRules()
    createDialog.value = false
    snackbar.success(t('club.rules.rules_created'))
    edit.value = false
  } catch (error) {
    const detail = error.response?.data?.error || error.response?.data?.detail || t('club.rules.error_create_failed');
    snackbar.error(t('club.rules.error_create_failed', { detail }));
    console.error(error)
  }
}


</script>
